
export class MessageApi {
    key: string;
    value: string;
}

export const KEY_API: MessageApi[] = [
    { key: 'email_in_use', value: 'Email đã được sử dụng' },
    { key: 'invalid_credentials', value: 'Thông tin không hợp lệ' },
    { key: 'invalid_current_password', value: 'Mật khẩu hiện tại không hợp lệ' },
    { key: 'invalid_email', value: 'Email không hợp lệ' },
    { key: 'invalid_password', value: 'Mật khẩu không hợp lệ' },
    { key: 'invalid_role', value: 'Quyền không hợp lệ' },
    { key: 'refresh_token_not_found', value: 'Mã thông báo không được tìm thấy' },
    { key: 'refresh_token_already_revoked', value: 'Mã thông báo đã bị thu hồi' },
    { key: 'user_not_found', value: 'Người dùng không được tìm thấy' },
    { key: 'department_name_is_exists', value: 'Mã đơn vị đã tồn tại.' },
    { key: 'department_code_is_exists', value: 'Tên đơn vị đã tồn tại.' },
    { key: 'file_format_fail', value: 'File không đúng định dạng.' },
];


export function getMessaggeByCode(code: string): string {
    try {
        const message = KEY_API.find(x => x.key === code);
        if (message) {
            code = message.value;
        }
    }
    catch (e) {
    }
    return code;
}
